import commonConstant from '../../common/_commonConstant';

export const userErrorDetail = detail => {
  try {
    switch (detail) {
      case 'failed to create user resource: username already exist':
        return commonConstant.userManagementUsernameExist;
      case 'username must be over or equal 5 characters.':
        return commonConstant.userManagementUsernameFiveChars;
      default:
        return false;
    }
  } catch (error) {
    return false;
  }
};

export const isNewCreatedUser = time => {
  try {
    return (new Date().getTime() - new Date(time).getTime()) < 30000 ? true : false;
  } catch (error) {
    return false;
  }
};

export const filterUser = (type, data) => {
  try {
    let items = '';
    if (data && data.length > 0) {
      for (const [index, ele] of data.entries()) {
        if (ele.type === type) {
          items = items ? `${items},${ele.label}` : ele.label;
        }
        if (data.length === index + 1) {
          return items;
        }
      }
    }
    return null;
  } catch (error) {
    return false;
  }
};

export const isNotDuplicateFilter = (value, filter) => {
  try {
    if (filter && filter.length > 0) {
      for (const [index, ele] of filter.entries()) {
        if (ele.label === value) {
          return false;
        }
        if (filter.length === index + 1) {
          return true;
        }
        continue;
      }
    }
    return true;
  } catch (error) {
    return false;
  }
};
